import React from 'react'

export function NotFoundPage() {
    return (
        <div className="w-100 text-center">
            <h1>The Page you are looking for could not be found</h1>
        </div>
    )
}
